import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import type { PageTitleKey } from '@/lib/page-title'

import { pageTitle } from '@/lib/page-title'

export function useDocumentTitle(key: PageTitleKey) {
  const { t } = useTranslation('common')

  useEffect(() => {
    document.title = pageTitle(t(`pageTitles.${key}`))
  }, [t, key])
}
